
<template>
  <div class="protect-apply">
    <div class="header">
      <div class="tab-wrap">
        <ul class="tab-list">
          <li
            class="tab-item"
            v-for="(item, index) in tabList"
            :key="index"
            @click="tabChange(index, item.value)"
            :class="activeIndex == index ? 'active' : ''"
          >
            {{ item.label }}
          </li>
        </ul>
      </div>
    </div>
    <div
      ref="form"
      class="form"
      style="position: relative"
      @scroll="handleScroll"
    >
      <slot name="form"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "form_common",
  props: ["title", "tabList", "activeKey", "scrollDiff", "judge"],
  data() {
    return {
      activeIndex: "",
      topArr: [],
    };
  },
  watch: {
    activeKey() {

    },
  },
  mounted() {
    let arrDom = document.getElementsByClassName("item-content");
    this.topArr = [];
    for (let i = 0; i < arrDom.length; i++) {
      this.topArr.push(arrDom[i].offsetTop);
    }

    setTimeout(() => {
      if (this.judge == 1) {
        this.tabChange(7);
      } else if (this.judge == "") {
        this.tabChange(this.activeKey);
      }
    }, 100);
  },
  methods: {
    // 切换tab
    tabChange(index) {
      this.activeIndex = index;
      let father = this.$refs["form"];
      let children = document.getElementsByClassName("item-content");
      father.scrollTo(0, children[index].offsetTop);
    },
    // 滚动切换tab
    handleScroll(e) {
      let father = this.$refs["form"];
      const current_offset_top = father.scrollTop;
      for (let i = 0; i < this.topArr.length; i++) {
        if (current_offset_top <= this.topArr[i] + this.scrollDiff) {
          // 根据滚动距离判断应该滚动到第几个导航的位置
          this.activeIndex = i;
          break;
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.protect-apply {
  width: 100%;
  height: 100%;
  margin-top: -8px;

  .header {
    width: calc(100% + 32px);
    background-color: #fff;
    margin-left: -16px;
    /*border-left: 2px solid #F2F2F2;*/

    .title {
      padding: 5px 0;
      text-align: center;
      border-bottom: 1px solid #e3e8f3;
    }

    /* .operation {
         display: flex;
         justify-content: space-between;
         align-items: center;
         padding: 5px 0;
         border-bottom: 1px solid #E3E8F3;
       }*/

    .tab-wrap {
      padding: 10px;
      position: relative;

      .tab-list {
        border-bottom: 1px solid #e3e8f3;
        list-style: none; /*清除列表默认样式*/
        margin: 0;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        padding-bottom: 5px;

        .tab-item {
          margin-right: 40px;
          position: relative;
          cursor: pointer;
          // background-color:#B71C1C;
          &:hover {
            color: #b71c1c;
          }

          &.active {
            color: #b71c1c;

            &:after {
              content: "";
              display: inline-block;
              height: 2px;
              background-color: #b71c1c;
              width: 100%;
              position: absolute;
              left: 0;
              bottom: -6px;
            }
          }
        }
      }
    }
  }

  .form {
    height: calc(100vh - 233px);
    overflow: auto;

    .form-title {
      font-weight: normal;
      text-align: center;
    }

    .formItem {
      display: flex;
      justify-content: space-between;
    }

    .twoFormItem {
      width: 49%;
    }

    .file-upload {
      border: 1px dashed #d6d6d6;
      padding: 10px;
      background-color: #f5f5f5;
      display: flex;
      align-items: center;
    }
  }
}
</style>
